// utils/browserNotification/notify.ts - utils/browserNotification.ts split (sub-module notify)


import type {BrowserNotificationOptions} from './types.js';
import { isNotificationSupported } from './permission.js';


/**
 * Show a browser notification
 * Works even when tab is not active (if service worker is registered)
 */
export async function showBrowserNotification(options: BrowserNotificationOptions): Promise<boolean> {
  if (!isNotificationSupported()) {
    console.warn('Browser notifications not supported');
    return false;
  }

  // Check permission
  if (Notification.permission !== 'granted') {
    console.warn('Notification permission not granted');
    return false;
  }

  try {
    // Try to use service worker for background notifications
    if ('serviceWorker' in navigator) {
      const registration = await navigator.serviceWorker.ready;

      await registration.showNotification(options.title, {
        body: options.body,
        icon: options.icon || '/vite.svg',
        badge: options.badge || '/vite.svg',
        tag: options.tag || `notification-${Date.now()}`,
        requireInteraction: options.requireInteraction || false,
        silent: options.silent || false,
        vibrate: [200, 100, 200],
        data: options.data || {},
        actions: [
          { action: 'open', title: 'Buka' },
          { action: 'close', title: 'Tutup' },
        ],
      } as NotificationOptions);

      return true;
    }

    // Fallback to regular notification (only works when tab is active)
    const notification = new Notification(options.title, {
      body: options.body,
      icon: options.icon || '/vite.svg',
      badge: options.badge || '/vite.svg',
      tag: options.tag || `notification-${Date.now()}`,
      requireInteraction: options.requireInteraction || false,
      silent: options.silent || false,
      data: options.data || {},
    });

    // Auto close after 5 seconds
    setTimeout(() => {
      notification.close();
    }, 5000);

    return true;
  } catch (error) {
    console.error('Error showing browser notification:', error);
    return false;
  }
}
